import { Directive } from "vue";
import { safeHtml } from "@/helpers/locale";

function setSafeHtml(element: HTMLElement, value: unknown): void {
  element.innerHTML = safeHtml(value);
}

export const safeHtmlDirective: Directive<HTMLElement, unknown> = {
  beforeMount(element, binding) {
    setSafeHtml(element, binding.value);
  },
  updated(element, binding) {
    if (binding.value === binding.oldValue) return;

    setSafeHtml(element, binding.value);
  },
};
